import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewTermoDeUso from "../views/ViewTermoDeUso";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";

const ContainerPagina = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
`;

const ConteudoPrincipal = styled.main`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const TermoDeUso: React.FC = () => (
  <>
    <ContatoZap />
    <ContainerPagina>
      <ViewAppBar />
      <ConteudoPrincipal>
        <ViewTermoDeUso />
      </ConteudoPrincipal>
      <ViewFooter />
    </ContainerPagina>
  </>
);

export default TermoDeUso;